import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "992d2781-00fd-436b-9438-5a44fb69a13a",
  publicId: "25",
  name: "Influence of absorption on sound insulation (or how room acoustics influences building acoustics)",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
